import Link from 'next/link';
import { ROUTES } from '@/routes';
import AnimatedLine from './animations/animated-line';

type Props = {
  className?: string;
};

export const CallToAction: React.FC<Props> = ({ className = '' }) => {
  return (
    <div
      className={`ring-copper/20 dark:bg-dark relative overflow-hidden rounded-lg bg-white ring-2 ring-inset dark:ring-2 dark:ring-white/20 ${className}`}>
      <div className="px-4 py-6 sm:px-8">
        <div className="text-dark dark:text-ivory mt-5 max-w-2xl text-2xl font-light">
          {/* Let's turn bold ideas into beautiful, high-performing products. */}
          {/* Not sure what your next step is? I’d love to hear about it — no pitch,
					no pressure. */}
          {/* Create a product that looks amazing and drives real growth. */}
          Have an idea? Let's design it, build it, and ship it.
        </div>
        <Link
          href={ROUTES.CONTACT}
          passHref
          className="group flex items-center justify-between pt-6">
          <div className="text-dark dark:text-ivory group h-12 overflow-hidden font-serif text-5xl tracking-tight lg:h-24 lg:text-8xl">
            <div className="translate-y-0 transition-all duration-300 group-hover:-translate-y-full">
              Let&rsquo;s <span className="hidden sm:inline">Build It</span>
              <span className="sm:hidden">Build</span>
            </div>
            <div className="transition-all duration-300 group-hover:-translate-y-full">
              Let&rsquo;s Talk
            </div>
          </div>

          <div className="border-primary-500 text-primary-500 group group-hover:bg-primary-500 relative box-border flex items-center justify-center overflow-hidden rounded-full border-2 px-5 py-3 transition-all group-hover:text-white lg:px-10 lg:py-4">
            <svg
              className="size-6 transition-all group-hover:-translate-x-24 lg:size-10"
              viewBox="0 0 18 15"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M 1 7.4 L 15.857 7.4 M 17 7.4 L 10.6 1 M 17 7.4 L 10.6 13.8"
                strokeWidth="2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"></path>
            </svg>
            <svg
              className="absolute size-10 translate-x-48 transition-all group-hover:translate-x-0"
              viewBox="0 0 18 15"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M 1 7.4 L 15.857 7.4 M 17 7.4 L 10.6 1 M 17 7.4 L 10.6 13.8"
                strokeWidth="2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"></path>
            </svg>
          </div>
        </Link>
      </div>

      <AnimatedLine
        delay={0}
        positionClass="top-0 -left-[71px]"
        fromClass="from-primary-500"
        toClass="to-primary-500/0"
        className="dark:from-white dark:to-white/0"
      />

      <AnimatedLine
        delay={1.5}
        positionClass="top-0 -right-[71px]"
        fromClass="from-primary-500"
        toClass="to-primary-500/0"
        className="dark:from-white dark:to-white/0"
      />
    </div>
  );
};
